import {
  GET_ARTICLE,
  GET_ARTICLE_FAIL,
  GET_ARTICLE_SUCCESS,
  GET_ARTICLE_DETAILS,
  GET_ARTICLE_DETAILS_FAIL,
  GET_ARTICLE_DETAILS_SUCCESS,
  ADD_NEW_ARTICLE,
  ADD_ARTICLE_SUCCESS,
  ADD_ARTICLE_FAIL,
  UPDATE_ARTICLE,
  UPDATE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_FAIL,
  DELETE_ARTICLE,
  DELETE_ARTICLE_SUCCESS,
  DELETE_ARTICLE_FAIL,
  RESET_ARTICLE_STATE,
} from "./actionTypes";

export const getArticle = ({length, page, name, status,}) => ({
  type: GET_ARTICLE,
  payload: {length, page, name, status},
});

export const getArticleSuccess = article => ({
  type: GET_ARTICLE_SUCCESS,
  payload: article,
});

export const getArticleFail = error => ({
  type: GET_ARTICLE_FAIL,
  payload: error,
});

export const getArticleDetails = ({id}) => ({
  type: GET_ARTICLE_DETAILS,
  payload: {id},
});

export const getArticleDetailsSuccess = article => ({
  type: GET_ARTICLE_DETAILS_SUCCESS,
  payload: article,
});

export const getArticleDetailsFail = error => ({
  type: GET_ARTICLE_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewArticle = article => ({
  type: ADD_NEW_ARTICLE,
  payload: article,
});

export const addArticleSuccess = article => ({
  type: ADD_ARTICLE_SUCCESS,
  payload: article,
});

export const addArticleFail = error => ({
  type: ADD_ARTICLE_FAIL,
  payload: error,
});

//update 
export const updateArticle =({id, article}) => ({
  type: UPDATE_ARTICLE,
  payload:{id, article},
});

export const updateArticleSuccess = article => ({
  type: UPDATE_ARTICLE_SUCCESS,
  payload: article,
});

export const updateArticleFail = error => ({
  type: UPDATE_ARTICLE_FAIL,
  payload: error,
});

//delete 
export const deleteArticle =({id}) => ({
  type: DELETE_ARTICLE,
  payload:{id},
});

export const deleteArticleSuccess = article => ({
  type: DELETE_ARTICLE_SUCCESS,
  payload: article,
});

export const deleteArticleFail = error => ({
  type: DELETE_ARTICLE_FAIL,
  payload: error,
});

export const resetArticlerState = () => {
  return {
      type: RESET_ARTICLE_STATE,
  }
}